const COUNTRY_LIST = [
  {code:"US",name:"United States",dial_code:"+1"},
  {code:"CA",name:"Canada",dial_code:"+1"},
  {code:"AU",name:"Australia",dial_code:"+61"},
  {code:"GB",name:"United Kingdom",dial_code:"+44"},
  {code:"AF",name:"Afghanistan",dial_code:"+93"},
  {code:"AX",name:"Aland Islands",dial_code:"+358"},
  {code:"AL",name:"Albania",dial_code:"+355"},
  {code:"DZ",name:"Algeria",dial_code:"+213"},
  {code:"AS",name:"American Samoa",dial_code:"+1"},
  {code:"AD",name:"Andorra",dial_code:"+376"},
  {code:"AO",name:"Angola",dial_code:"+244"},
  {code:"AI",name:"Anguilla",dial_code:"+1"},
  {code:"AQ",name:"Antarctica",dial_code:""},
  {code:"AG",name:"Antigua and Barbuda",dial_code:"+1"},
  {code:"AR",name:"Argentina",dial_code:"+54"},
  {code:"AM",name:"Armenia",dial_code:"+374"},
  {code:"AW",name:"Aruba",dial_code:"+297"},
  {code:"AT",name:"Austria",dial_code:"+43"},
  {code:"AZ",name:"Azerbaijan",dial_code:"+994"},
  {code:"BS",name:"Bahamas",dial_code:"+1"},
  {code:"BH",name:"Bahrain",dial_code:"+973"},
  {code:"BD",name:"Bangladesh",dial_code:"+880"},
  {code:"BB",name:"Barbados",dial_code:"+1"},
  {code:"BY",name:"Belarus",dial_code:"+375"},
  {code:"BE",name:"Belgium",dial_code:"+32"},
  {code:"BZ",name:"Belize",dial_code:"+501"},
  {code:"BJ",name:"Benin",dial_code:"+229"},
  {code:"BM",name:"Bermuda",dial_code:"+1"},
  {code:"BT",name:"Bhutan",dial_code:"+975"},
  {code:"BO",name:"Bolivia",dial_code:"+591"},
  {code:"BQ",name:"Bonaire, Sint Eustatius and Saba",dial_code:"+599"},
  {code:"BA",name:"Bosnia and Herzegovina",dial_code:"+387"},
  {code:"BW",name:"Botswana",dial_code:"+267"},
  {code:"BV",name:"Bouvet Island",dial_code:""},
  {code:"BR",name:"Brazil",dial_code:"+55"},
  {code:"IO",name:"British Indian Ocean Territory",dial_code:"+246"},
  {code:"BN",name:"Brunei Darussalam",dial_code:"+673"},
  {code:"BG",name:"Bulgaria",dial_code:"+359"},
  {code:"BF",name:"Burkina Faso",dial_code:"+226"},
  {code:"BI",name:"Burundi",dial_code:"+257"},
  {code:"KH",name:"Cambodia",dial_code:"+855"},
  {code:"CM",name:"Cameroon",dial_code:"+237"},
  {code:"CV",name:"Cabo Verde",dial_code:"+238"},
  {code:"KY",name:"Cayman Islands",dial_code:"+1"},
  {code:"CF",name:"Central African Republic",dial_code:"+236"},
  {code:"TD",name:"Chad",dial_code:"+235"},
  {code:"CL",name:"Chile",dial_code:"+56"},
  {code:"CN",name:"China",dial_code:"+86"},
  {code:"CX",name:"Christmas Island",dial_code:"+61"},
  {code:"CC",name:"Cocos (Keeling) Islands",dial_code:"+61"},
  {code:"CO",name:"Colombia",dial_code:"+57"},
  {code:"KM",name:"Comoros",dial_code:"+269"},
  {code:"CG",name:"Congo",dial_code:"+242"},
  {code:"CD",name:"Congo, Democratic Republic of the",dial_code:"+243"},
  {code:"CK",name:"Cook Islands",dial_code:"+682"},
  {code:"CR",name:"Costa Rica",dial_code:"+506"},
  {code:"CI",name:"Côte d’Ivoire",dial_code:"+225"},
  {code:"HR",name:"Croatia",dial_code:"+385"},
  {code:"CU",name:"Cuba",dial_code:"+53"},
  {code:"CW",name:"Curaçao",dial_code:"+599"},
  {code:"CY",name:"Cyprus",dial_code:"+357"},
  {code:"CZ",name:"Czech Republic",dial_code:"+420"},
  {code:"DK",name:"Denmark",dial_code:"+45"},
  {code:"DJ",name:"Djibouti",dial_code:"+253"},
  {code:"DM",name:"Dominica",dial_code:"+1"},
  {code:"DO",name:"Dominican Republic",dial_code:"+1"},
  {code:"EC",name:"Ecuador",dial_code:"+593"},
  {code:"EG",name:"Egypt",dial_code:"+20"},
  {code:"SV",name:"El Salvador",dial_code:"+503"},
  {code:"GQ",name:"Equatorial Guinea",dial_code:"+240"},
  {code:"ER",name:"Eritrea",dial_code:"+291"},
  {code:"EE",name:"Estonia",dial_code:"+372"},
  {code:"SZ",name:"Eswatini",dial_code:"+268"},
  {code:"ET",name:"Ethiopia",dial_code:"+251"},
  {code:"FK",name:"Falkland Islands",dial_code:"+500"},
  {code:"FO",name:"Faroe Islands",dial_code:"+298"},
  {code:"FJ",name:"Fiji",dial_code:"+679"},
  {code:"FI",name:"Finland",dial_code:"+358"},
  {code:"FR",name:"France",dial_code:"+33"},
  {code:"GF",name:"French Guiana",dial_code:"+594"},
  {code:"PF",name:"French Polynesia",dial_code:"+689"},
  {code:"TF",name:"French Southern Territories",dial_code:""},
  {code:"GA",name:"Gabon",dial_code:"+241"},
  {code:"GM",name:"Gambia",dial_code:"+220"},
  {code:"GE",name:"Georgia",dial_code:"+995"},
  {code:"DE",name:"Germany",dial_code:"+49"},
  {code:"GH",name:"Ghana",dial_code:"+233"},
  {code:"GI",name:"Gibraltar",dial_code:"+350"},
  {code:"GR",name:"Greece",dial_code:"+30"},
  {code:"GL",name:"Greenland",dial_code:"+299"},
  {code:"GD",name:"Grenada",dial_code:"+1"},
  {code:"GP",name:"Guadeloupe",dial_code:"+590"},
  {code:"GU",name:"Guam",dial_code:"+1"},
  {code:"GT",name:"Guatemala",dial_code:"+502"},
  {code:"GG",name:"Guernsey",dial_code:"+44"},
  {code:"GN",name:"Guinea",dial_code:"+224"},
  {code:"GW",name:"Guinea-Bissau",dial_code:"+245"},
  {code:"GY",name:"Guyana",dial_code:"+592"},
  {code:"HT",name:"Haiti",dial_code:"+509"},
  {code:"HN",name:"Honduras",dial_code:"+504"},
  {code:"HK",name:"Hong Kong",dial_code:"+852"},
  {code:"HU",name:"Hungary",dial_code:"+36"},
  {code:"IS",name:"Iceland",dial_code:"+354"},
  {code:"IN",name:"India",dial_code:"+91"},
  {code:"ID",name:"Indonesia",dial_code:"+62"},
  {code:"IR",name:"Iran",dial_code:"+98"},
  {code:"IQ",name:"Iraq",dial_code:"+964"},
  {code:"IE",name:"Ireland",dial_code:"+353"},
  {code:"IM",name:"Isle of Man",dial_code:"+44"},
  {code:"IL",name:"Israel",dial_code:"+972"},
  {code:"IT",name:"Italy",dial_code:"+39"},
  {code:"JM",name:"Jamaica",dial_code:"+1"},
  {code:"JP",name:"Japan",dial_code:"+81"},
  {code:"JE",name:"Jersey",dial_code:"+44"},
  {code:"JO",name:"Jordan",dial_code:"+962"},
  {code:"KZ",name:"Kazakhstan",dial_code:"+7"},
  {code:"KE",name:"Kenya",dial_code:"+254"},
  {code:"KI",name:"Kiribati",dial_code:"+686"},
  {code:"KP",name:"Korea (North)",dial_code:"+850"},
  {code:"KR",name:"Korea (South)",dial_code:"+82"},
  {code:"KW",name:"Kuwait",dial_code:"+965"},
  {code:"KG",name:"Kyrgyzstan",dial_code:"+996"},
  {code:"LA",name:"Lao People's Democratic Republic",dial_code:"+856"},
  {code:"LV",name:"Latvia",dial_code:"+371"},
  {code:"LB",name:"Lebanon",dial_code:"+961"},
  {code:"LS",name:"Lesotho",dial_code:"+266"},
  {code:"LR",name:"Liberia",dial_code:"+231"},
  {code:"LY",name:"Libya",dial_code:"+218"},
  {code:"LI",name:"Liechtenstein",dial_code:"+423"},
  {code:"LT",name:"Lithuania",dial_code:"+370"},
  {code:"LU",name:"Luxembourg",dial_code:"+352"},
  {code:"MO",name:"Macao",dial_code:"+853"},
  {code:"MG",name:"Madagascar",dial_code:"+261"},
  {code:"MW",name:"Malawi",dial_code:"+265"},
  {code:"MY",name:"Malaysia",dial_code:"+60"},
  {code:"MV",name:"Maldives",dial_code:"+960"},
  {code:"ML",name:"Mali",dial_code:"+223"},
  {code:"MT",name:"Malta",dial_code:"+356"},
  {code:"MH",name:"Marshall Islands",dial_code:"+692"},
  {code:"MQ",name:"Martinique",dial_code:"+596"},
  {code:"MR",name:"Mauritania",dial_code:"+222"},
  {code:"MU",name:"Mauritius",dial_code:"+230"},
  {code:"YT",name:"Mayotte",dial_code:"+262"},
  {code:"MX",name:"Mexico",dial_code:"+52"},
  {code:"FM",name:"Micronesia",dial_code:"+691"},
  {code:"MD",name:"Moldova",dial_code:"+373"},
  {code:"MC",name:"Monaco",dial_code:"+377"},
  {code:"MN",name:"Mongolia",dial_code:"+976"},
  {code:"ME",name:"Montenegro",dial_code:"+382"},
  {code:"MS",name:"Montserrat",dial_code:"+1"},
  {code:"MA",name:"Morocco",dial_code:"+212"},
  {code:"MZ",name:"Mozambique",dial_code:"+258"},
  {code:"MM",name:"Myanmar",dial_code:"+95"},
  {code:"NA",name:"Namibia",dial_code:"+264"},
  {code:"NR",name:"Nauru",dial_code:"+674"},
  {code:"NP",name:"Nepal",dial_code:"+977"},
  {code:"NL",name:"Netherlands",dial_code:"+31"},
  {code:"NC",name:"New Caledonia",dial_code:"+687"},
  {code:"NZ",name:"New Zealand",dial_code:"+64"},
  {code:"NI",name:"Nicaragua",dial_code:"+505"},
  {code:"NE",name:"Niger",dial_code:"+227"},
  {code:"NG",name:"Nigeria",dial_code:"+234"},
  {code:"NU",name:"Niue",dial_code:"+683"},
  {code:"NF",name:"Norfolk Island",dial_code:"+672"},
  {code:"MK",name:"North Macedonia",dial_code:"+389"},
  {code:"MP",name:"Northern Mariana Islands",dial_code:"+1"},
  {code:"NO",name:"Norway",dial_code:"+47"},
  {code:"OM",name:"Oman",dial_code:"+968"},
  {code:"PK",name:"Pakistan",dial_code:"+92"},
  {code:"PW",name:"Palau",dial_code:"+680"},
  {code:"PS",name:"Palestine",dial_code:"+970"},
  {code:"PA",name:"Panama",dial_code:"+507"},
  {code:"PG",name:"Papua New Guinea",dial_code:"+675"},
  {code:"PY",name:"Paraguay",dial_code:"+595"},
  {code:"PE",name:"Peru",dial_code:"+51"},
  {code:"PH",name:"Philippines",dial_code:"+63"},
  {code:"PL",name:"Poland",dial_code:"+48"},
  {code:"PT",name:"Portugal",dial_code:"+351"},
  {code:"PR",name:"Puerto Rico",dial_code:"+1"},
  {code:"QA",name:"Qatar",dial_code:"+974"},
  {code:"RE",name:"Réunion",dial_code:"+262"},
  {code:"RO",name:"Romania",dial_code:"+40"},
  {code:"RU",name:"Russian Federation",dial_code:"+7"},
  {code:"RW",name:"Rwanda",dial_code:"+250"},
  {code:"SA",name:"Saudi Arabia",dial_code:"+966"},
  {code:"SG",name:"Singapore",dial_code:"+65"},
  {code:"ZA",name:"South Africa",dial_code:"+27"},
  {code:"ES",name:"Spain",dial_code:"+34"},
  {code:"SE",name:"Sweden",dial_code:"+46"},
  {code:"CH",name:"Switzerland",dial_code:"+41"},
  {code:"TW",name:"Taiwan",dial_code:"+886"},
  {code:"TH",name:"Thailand",dial_code:"+66"},
  {code:"TR",name:"Turkey",dial_code:"+90"},
  {code:"UA",name:"Ukraine",dial_code:"+380"},
  {code:"AE",name:"United Arab Emirates",dial_code:"+971"},
  {code:"UY",name:"Uruguay",dial_code:"+598"},
  {code:"UZ",name:"Uzbekistan",dial_code:"+998"},
  {code:"VN",name:"Viet Nam",dial_code:"+84"},
  {code:"YE",name:"Yemen",dial_code:"+967"},
  {code:"ZM",name:"Zambia",dial_code:"+260"},
  {code:"ZW",name:"Zimbabwe",dial_code:"+263"}
];

class TraderFormAccessibility {
  static getErrorTarget(element) {
    if (!element) return null;
    if (element.classList?.contains('ctm-sign-trader__search-select')) {
      return element.querySelector('.ctm-sign-trader__search-select-trigger');
    }
    if (element.type === 'hidden' && element.closest('.ctm-sign-trader__search-select')) {
      return element.closest('.ctm-sign-trader__search-select').querySelector('.ctm-sign-trader__search-select-trigger');
    }
    if (element.classList?.contains('ctm-sign-trader__search-select-trigger')) return element;
    if (element.id === 'documents') return document.querySelector('.ctm-upload-btn') || element;
    if (element.tagName === 'LABEL') return element.querySelector('input') || element;
    return element;
  }

  static setFieldError(element, errorElement) {
    const target = this.getErrorTarget(element);
    if (!target || !errorElement) return;

    if (!errorElement.id) {
      const targetId = target.id || target.getAttribute('aria-controls') || target.name || 'field';
      errorElement.id = `${targetId}-error`;
    }

    target.setAttribute('aria-invalid', 'true');
    target.setAttribute('aria-describedby', this.mergeIdList(target.getAttribute('aria-describedby'), errorElement.id));
  }

  static clearFieldError(element, parent) {
    const target = this.getErrorTarget(element);
    if (!target) return;

    const errorIds = Array.from(parent?.querySelectorAll('.ctm-sign-trader__error') || [])
      .map(error => error.id)
      .filter(Boolean);

    target.removeAttribute('aria-invalid');
    errorIds.forEach(id => this.removeDescribedBy(target, id));
  }

  static mergeIdList(currentValue, id) {
    const ids = new Set((currentValue || '').split(/\s+/).filter(Boolean));
    ids.add(id);
    return Array.from(ids).join(' ');
  }

  static removeDescribedBy(element, id) {
    const ids = (element.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean).filter(item => item !== id);
    if (ids.length) element.setAttribute('aria-describedby', ids.join(' '));
    else element.removeAttribute('aria-describedby');
  }

  static setupSearchSelect({ container, trigger, dropdown, searchInput, optionsContainer, hiddenInput }) {
    if (!container || !trigger || !dropdown || !optionsContainer || !hiddenInput) return;

    const baseId = container.id || hiddenInput.id || `search-select-${Math.random().toString(36).slice(2)}`;
    const dropdownId = `${baseId}-dropdown`;

    trigger.id = trigger.id || `${baseId}-trigger`;
    dropdown.id = dropdown.id || dropdownId;
    optionsContainer.id = optionsContainer.id || `${baseId}-options`;

    trigger.removeAttribute('aria-haspopup');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-controls', dropdown.id);
    trigger.setAttribute('aria-labelledby', `${this.getLabelId(hiddenInput)} ${trigger.id}`.trim());

    dropdown.setAttribute('role', 'group');
    dropdown.setAttribute('aria-labelledby', this.getLabelId(hiddenInput) || trigger.id);

    if (searchInput) {
      searchInput.setAttribute('aria-label', `Search ${this.getLabelText(hiddenInput) || 'options'}`);
    }
  }

  static getLabelId(input) {
    if (!input?.id) return '';
    const label = document.querySelector(`label[for="${input.id}"]`);
    if (!label) return '';
    label.id = label.id || `${input.id}-label`;
    return label.id;
  }

  static getLabelText(input) {
    if (!input?.id) return '';
    return document.querySelector(`label[for="${input.id}"]`)?.innerText?.replace('*', '').trim() || '';
  }

  static updateSearchExpanded(trigger, isOpen) {
    trigger?.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }

  static setupSearchOption(optionElement, optionData, isSelected, prefix = 'search-select') {
    optionElement.type = 'button';
    optionElement.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    const valueId = optionData.value.toString().replace(/[^a-z0-9_-]+/gi, '-').toLowerCase();
    optionElement.id = optionElement.id || `${prefix}-${valueId}-option`;
  }

  static updateSelectedOption(optionsContainer, selectedElement) {
    optionsContainer.querySelectorAll('.ctm-sign-trader__search-select-option').forEach(option => {
      const isSelected = option === selectedElement;
      option.classList.toggle('selected', isSelected);
      option.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });
  }

  static getVisibleOptions(optionsContainer) {
    return Array.from(optionsContainer.querySelectorAll('.ctm-sign-trader__search-select-option:not(.hidden)'));
  }

  static focusOption(optionsContainer, option) {
    if (!option) return;
    option.focus();
  }

  static updateStep({ stepContents, currentStep, steps, shouldFocus = false }) {
    stepContents.forEach((content, index) => {
      const isCurrent = index + 1 === currentStep;
      content.hidden = !isCurrent;
      content.setAttribute('aria-hidden', isCurrent ? 'false' : 'true');
    });

    const progressBar = document.querySelector('.ctm-sign-trader__progress-bar');
    if (progressBar) {
      progressBar.setAttribute('aria-valuenow', String(currentStep));
      progressBar.setAttribute('aria-valuetext', `Step ${currentStep} of ${steps.length}`);
    }

    if (shouldFocus) {
      document.querySelector(`#step-${currentStep} .ctm-sign-trader__form-title`)?.focus({ preventScroll: true });
    }
  }

  static setupUploadDisclosure(toggle, content) {
    if (!toggle || !content) return;
    toggle.setAttribute('aria-expanded', content.hidden ? 'false' : 'true');
  }

  static updateUploadDisclosure(toggle, content, isOpen) {
    if (!toggle || !content) return;
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    content.hidden = !isOpen;
  }

  static getFocusable(container) {
    return Array.from(container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'))
      .filter(element => !element.disabled && element.offsetParent !== null);
  }

  static focusField(element) {
    const target = this.getErrorTarget(element);
    if (!target) return;
    if (!target.hasAttribute('tabindex') && !/^(A|BUTTON|INPUT|SELECT|TEXTAREA)$/.test(target.tagName)) {
      target.setAttribute('tabindex', '-1');
    }
    target.focus();
  }
}

function showError(element, message) {
  let parent = element.parentNode;
  
  if (parent.classList.contains('ctm-phone-input-wrapper')) {
    parent = parent.parentNode;
  }
  
  const existing = parent.querySelectorAll('.ctm-sign-trader__error');
  existing.forEach(e => e.remove());

  const errorElement = document.createElement('div');
  errorElement.className = 'ctm-sign-trader__error';
  errorElement.setAttribute('role', 'alert');
  errorElement.textContent = message;
  errorElement.style.display = 'block';

  parent.appendChild(errorElement);
  TraderFormAccessibility.setFieldError(element, errorElement);
}

function hideError(element) {
  let parent = element.parentNode;
  
  if (parent.classList.contains('ctm-phone-input-wrapper')) {
    parent = parent.parentNode;
  }
  
  TraderFormAccessibility.clearFieldError(element, parent);
  const existing = parent.querySelectorAll('.ctm-sign-trader__error');
  existing.forEach(e => e.remove());
}
document.addEventListener('DOMContentLoaded', async function () {
  const apiBaseUrl = theme.ctm.apiBaseUrl;
  const steps = ['step-1', 'step-2'];
  const stepContents = steps.map(step => document.getElementById(step));
  const traderTitle = document.querySelector('.ctm-sign-trader__title');

  const nextButtons = document.querySelectorAll('.next-step');
  const prevButtons = document.querySelectorAll('.prev-step');
  const submitButton = document.getElementById('trader-submit');

  const countrySelect = document.getElementById('country');
  const provinceSelect = document.getElementById('province');
  const countryLoading = document.querySelector('#country-search-select + .ctm-sign-trader__loading') || document.querySelector('.ctm-sign-trader__loading');
  const provinceText = document.getElementById('province-text');

  function initSearchSelect(id, onSelect) {
    const container = document.getElementById(id);
    if (!container) return;

    const trigger = container.querySelector('.ctm-sign-trader__search-select-trigger');
    const dropdown = container.querySelector('.ctm-sign-trader__search-select-dropdown');
    const searchInput = container.querySelector('.ctm-sign-trader__search-select-search input');
    const optionsContainer = container.querySelector('.ctm-sign-trader__search-select-options');
    const hiddenInput = container.querySelector('input[type="hidden"]');
    const valueDisplay = container.querySelector('.ctm-sign-trader__search-select-value');
    TraderFormAccessibility.setupSearchSelect({ container, trigger, dropdown, searchInput, optionsContainer, hiddenInput });

    const toggleDropdown = (show) => {
      const isShow = show !== undefined ? show : dropdown.style.display === 'none';
      dropdown.style.display = isShow ? 'flex' : 'none';
      container.classList.toggle('open', isShow);
      TraderFormAccessibility.updateSearchExpanded(trigger, isShow);
      if (isShow) {
        const selectedOption = optionsContainer.querySelector('.ctm-sign-trader__search-select-option.selected');
        if (searchInput) searchInput.focus();
        else TraderFormAccessibility.focusOption(optionsContainer, selectedOption || TraderFormAccessibility.getVisibleOptions(optionsContainer)[0]);

        document.querySelectorAll('.ctm-sign-trader__search-select').forEach(el => {
          if (el !== container) {
            const otherDropdown = el.querySelector('.ctm-sign-trader__search-select-dropdown');
            const otherTrigger = el.querySelector('.ctm-sign-trader__search-select-trigger');
            otherDropdown.style.display = 'none';
            el.classList.remove('open');
            TraderFormAccessibility.updateSearchExpanded(otherTrigger, false);
          }
        });
      }
    };

    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      if (container.classList.contains('disabled')) return;
      toggleDropdown();
    });

    if (searchInput) {
      searchInput.addEventListener('click', (e) => e.stopPropagation());
      searchInput.addEventListener('input', (e) => {
        const filter = e.target.value.toLowerCase();
        const options = optionsContainer.querySelectorAll('.ctm-sign-trader__search-select-option');
        options.forEach(opt => {
          const text = opt.textContent.toLowerCase();
          opt.classList.toggle('hidden', !text.includes(filter));
        });
      });
    }

    const selectOption = (div, opt) => {
      hiddenInput.value = opt.value;
      valueDisplay.textContent = opt.text;

      TraderFormAccessibility.updateSelectedOption(optionsContainer, div);

      toggleDropdown(false);
      trigger.focus();
      if (searchInput) searchInput.value = '';
      const filterOptions = optionsContainer.querySelectorAll('.ctm-sign-trader__search-select-option');
      filterOptions.forEach(o => o.classList.remove('hidden'));

      if (onSelect) onSelect(opt);

      hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
    };

    const handleOptionsKeydown = (event) => {
      const options = TraderFormAccessibility.getVisibleOptions(optionsContainer);
      if (!options.length) return;

      const currentIndex = options.indexOf(document.activeElement);
      let nextIndex = currentIndex >= 0 ? currentIndex : 0;

      if (event.key === 'ArrowDown') nextIndex = currentIndex >= 0 ? Math.min(options.length - 1, currentIndex + 1) : 0;
      else if (event.key === 'ArrowUp') nextIndex = currentIndex >= 0 ? Math.max(0, currentIndex - 1) : options.length - 1;
      else if (event.key === 'Home') nextIndex = 0;
      else if (event.key === 'End') nextIndex = options.length - 1;
      else if (event.key === 'Escape') {
        event.preventDefault();
        toggleDropdown(false);
        trigger.focus();
        return;
      } else if (event.key === 'Enter' || event.key === ' ') {
        return;
      } else {
        return;
      }

      event.preventDefault();
      TraderFormAccessibility.focusOption(optionsContainer, options[nextIndex]);
    };

    trigger.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowDown' || event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        if (container.classList.contains('disabled')) return;
        toggleDropdown(true);
      } else if (event.key === 'Escape') {
        toggleDropdown(false);
      }
    });

    dropdown.addEventListener('keydown', handleOptionsKeydown);

    const setOptions = (options) => {
      optionsContainer.innerHTML = '';
      options.forEach(opt => {
        const div = document.createElement('button');
        div.className = 'ctm-sign-trader__search-select-option';
        div.textContent = opt.text;
        div.dataset.value = opt.value;
        if (opt.parentId) div.dataset.parentId = opt.parentId;
        TraderFormAccessibility.setupSearchOption(div, opt, hiddenInput.value === opt.value, container.id);

        div.addEventListener('click', (e) => {
          e.stopPropagation();
          selectOption(div, opt);
        });
        optionsContainer.appendChild(div);
      });
    };

    const setValue = (value, text) => {
      hiddenInput.value = value;
      valueDisplay.textContent = text || 'Select...';
      const options = optionsContainer.querySelectorAll('.ctm-sign-trader__search-select-option');
      options.forEach(opt => {
        const isSelected = opt.dataset.value === value;
        opt.classList.toggle('selected', isSelected);
        opt.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });
    };

    const disable = (isDisabled) => {
      container.classList.toggle('disabled', isDisabled);
      trigger.disabled = isDisabled;
      trigger.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');
      if (isDisabled) toggleDropdown(false);
    };

    return { setOptions, setValue, disable, toggleDropdown };
  }

  const countrySearch = initSearchSelect('country-search-select', (opt) => {
    loadProvinceList(opt.value);
    handlePhoneCountryCode(opt.value);
  });

  const provinceSearch = initSearchSelect('province-search-select', (opt) => {

  });

  const businessTypeSearch = initSearchSelect('business-type-search-select');
  const businessTypeOptions = [
    { text: 'Interior Designer / Decorator', value: 'Interior Designer / Decorator' },
    { text: 'Architect', value: 'Architect' },
    { text: 'Home Stager / Real Estate Styling', value: 'Home Stager / Real Estate Styling' },
    { text: 'Real Estate Developer / Investor', value: 'Real Estate Developer / Investor' },
    { text: 'Contractor / Builder', value: 'Contractor / Builder' },
    { text: 'Hospitality Professional', value: 'Hospitality Professional' },
    { text: 'Procurement / Sourcing Firm', value: 'Procurement / Sourcing Firm' },
    { text: 'Design Showroom', value: 'Design Showroom' },
    { text: 'Home Decor Retailer', value: 'Home Decor Retailer' },
  ];
  businessTypeSearch.setOptions(businessTypeOptions);

  const focusSearch = initSearchSelect('focus-search-select');
  const focusOptions = [
    { text: 'Residential (Single Family)', value: 'Residential (Single Family)' },
    { text: 'Multi-Unit Residential', value: 'Multi-Unit Residential' },
    { text: 'Commercial', value: 'Commercial' },
    { text: 'Hospitality', value: 'Hospitality' },
    { text: 'Multi-Disciplinary', value: 'Multi-Disciplinary' }
  ];
  focusSearch.setOptions(focusOptions);

  const hearAboutSearch = initSearchSelect('hear-about-search-select');
  const hearAboutOptions = [
    { text: 'Referral/Word of Mouth', value: 'Referral/Word of Mouth' },
    { text: 'Online Search', value: 'Online Search' },
    { text: 'Instagram', value: 'Instagram' },
    { text: 'Facebook', value: 'Facebook' },
    { text: 'Amazon', value: 'Amazon' },
    { text: 'Pinterest', value: 'Pinterest' },
    { text: 'Houzz', value: 'Houzz' },
    { text: 'Youtube', value: 'Youtube' },
    { text: 'Tiktok', value: 'Tiktok' },
    { text: 'Facebook group', value: 'Facebook group' },
    { text: 'Press', value: 'Press' },
    { text: 'Design Professional', value: 'Design Professional' },
    { text: 'Other', value: 'Other' }
  ];
  hearAboutSearch.setOptions(hearAboutOptions);

  document.addEventListener('click', () => {
    document.querySelectorAll('.ctm-sign-trader__search-select-dropdown').forEach(d => {
      d.style.display = 'none';
      d.parentElement.classList.remove('open');
      TraderFormAccessibility.updateSearchExpanded(d.parentElement.querySelector('.ctm-sign-trader__search-select-trigger'), false);
    });
  });

  const fileInput = document.getElementById('documents');

  const loadingOverlay = document.getElementById('loading-overlay');
  const ctmToast = document.getElementById('ctm-toast');

  let uploadedFiles = [];
  const MAX_FILES = 5;
  const MAX_FILE_SIZE = 10 * 1024 * 1024;

  let currentStep = 1;

  const urlParams = new URLSearchParams(window.location.search);
  const continueId = urlParams.get('continue');
  const stepParam = urlParams.get('step');
  const affParam = urlParams.get('aff');
  const rfe = urlParams.get('rfe');

  if (affParam) {
    // theme.utils.customFetch(`${apiBaseUrl}/trade-user/referrals/${affParam}`)
    //   .then(res => res.json())
    //   .then(res => {
    //     if (res.code === 200 && res.data) {
    //       const emailInput = document.getElementById('email');
    //       const emailToFill = res.data.inviteeEmail;
    //       if (emailInput && !emailInput.value && emailToFill) {
    //         emailInput.value = emailToFill;
    //       }
    //     }
    //   })
    //   .catch(err => console.error('Error fetching referral info:', err));
  }

  const uploadToggle = document.querySelector('.ctm-sign-trader__upload-toggle');
  const uploadInstructions = document.querySelector('.ctm-sign-trader__upload-instructions');
  TraderFormAccessibility.setupUploadDisclosure(uploadToggle, uploadInstructions);
  if (uploadToggle) {
    uploadToggle.addEventListener('click', () => {
      const content = uploadInstructions;
      const textSpan = uploadToggle.querySelector('.ctm-upload-toggle-text');
      const isOpen = content.style.display === 'none' || content.style.display === '';

      if (isOpen) {
        content.style.display = 'block';
        if (textSpan) textSpan.textContent = 'Hide accepted documents';
        uploadToggle.classList.add('expanded');
      } else {
        content.style.display = 'none';
        if (textSpan) textSpan.textContent = 'View accepted documents';
        uploadToggle.classList.remove('expanded');
      }

      TraderFormAccessibility.updateUploadDisclosure(uploadToggle, content, isOpen);
    });
  }

  if (continueId) {
    try {
      loadingOverlay.show('Loading...');

      const response = await fetch(`${apiBaseUrl}/trade-user/validate-continue-token?token=${continueId}`);
      if (response.status === 403) {
        loadingOverlay.hide();
        return;
      }
      const userData = await response.json();

      if (userData.data) {
        window.traderInfo = userData.data;
        window.code = userData.data.code;
        populateStep1Data(userData.data);
        populateStep2Data(userData.data);
        disableStepFields(userData.data);
        if (stepParam && ['1', '2'].includes(stepParam)) {
          currentStep = parseInt(stepParam);
          updateStepDisplay();
        }
      }
    } catch (error) {
      console.error('Error fetching user data:', error);
    } finally {
      loadingOverlay.hide();
    }
  }

  function populateStep1Data(data) {
    document.getElementById('company_name').value = data.companyName || '';
    document.getElementById('first_name').value = data.firstName || '';
    document.getElementById('last_name').value = data.lastName || '';
    document.getElementById('email').value = data.email || '';
    document.getElementById('job_title').value = data.jobTitle || '';
  }

  function populateStep2Data(data) {
    document.getElementById('website').value = data.website || '';
    document.getElementById('phone').value = data.phone || '';
    document.getElementById('street').value = data.streetAddress || '';
    document.getElementById('city').value = data.city || '';
    document.getElementById('apt').value = data.floor || '';
    document.getElementById('zip').value = data.zipCode || '';


    if (data.country) {
      document.getElementById('country').value = data.country;

    }


    if (data.province) {
      document.getElementById('province').value = data.province;

    }


    const bType = data.businessType || '';
    if (bType) {
      let value = bType;
      let text = bType;
      if (bType.startsWith('Other:')) {
        value = 'Other';
        text = 'Other';
        const otherInput = document.getElementById('business_type_other');
        otherInput.style.display = 'block';
        otherInput.value = bType.replace('Other:', '');
      }
      businessTypeSearch.setValue(value, text);
      document.getElementById('business_type').dispatchEvent(new Event('change'));
    }


    const pFocus = data.primaryBusinessFocus || '';
    if (pFocus) {
      const focusValue = pFocus.split(',')[0];
      focusSearch.setValue(focusValue, focusValue);
    }


    const hearFrom = data.hearFrom || '';
    if (hearFrom) {
      let value = hearFrom;
      let text = hearFrom;
      if (hearFrom.startsWith('Other:')) {
        value = 'Other';
        text = 'Other';
        const otherAppInput = document.getElementById('hear_about_specify');
        otherAppInput.style.display = 'block';
        otherAppInput.value = hearFrom.replace('Other:', '').trim();
      }

      hearAboutSearch.setValue(value, text);
      document.getElementById('hear_about').dispatchEvent(new Event('change'));

      if (hearFrom === 'Referral/Word of Mouth') {

        setTimeout(() => {
          const refInput = document.getElementById('referral_email_input');
          if (refInput) refInput.value = data.recommenderEmail || '';
        }, 0);
      }
    }

    if (data.message) {
      document.getElementById('message').value = data.message;
    }

    if (data.emailUpdatesConsent == '1') {
      document.getElementById('email_updates').checked = true;
    }
  }

  function disableStep1Fields(isDisabled = true) {
    const step1Inputs = document.querySelectorAll('#step-1 input, #step-1 select, #step-1 textarea');
    step1Inputs.forEach(input => {
      input.disabled = isDisabled;
    });
  }
  function disableStepFields(data) {
    disableStep1Fields()
    if (data.reviewStatus === 'approved' && data.status === 'submitted') {
      const step2Inputs = document.querySelectorAll('#step-2 input, #step-2 select, #step-2 textarea');
      step2Inputs.forEach(input => {
        input.disabled = true;
      });
      const traderImageRemoveIcon = document.querySelectorAll('.ctm-sign-trader__file-preview-remove');
      if (traderImageRemoveIcon) {
        traderImageRemoveIcon.forEach(item => {
          item.style.display = 'none';
        })
      }
      if (submitButton) submitButton.style.display = 'none';
    }
  }


  const businessTypeSelect = document.getElementById('business_type');
  if (businessTypeSelect) {
    businessTypeSelect.addEventListener('change', function () {
      const otherInput = document.getElementById('business_type_other');
      if (this.value === 'Other') {
        otherInput.style.display = 'block';
        otherInput.setAttribute('required', 'required');
      } else {
        otherInput.style.display = 'none';
        otherInput.removeAttribute('required');
        otherInput.value = '';
      }
    });
  }

  const hearAboutSelect = document.getElementById('hear_about');
  if (hearAboutSelect) {
    hearAboutSelect.addEventListener('change', function () {
      const otherInput = document.getElementById('hear_about_specify');
      const extraContainer = document.querySelector('.hear_about_extra_container');


      otherInput.style.display = 'none';
      otherInput.removeAttribute('required');
      extraContainer.innerHTML = '';
      extraContainer.style.display = 'none';

      if (this.value === 'Other') {
        otherInput.style.display = 'block';

        otherInput.setAttribute('placeholder', 'Please specify');
      }
    });
  }

  function initCountryList() {
    if (countryLoading) countryLoading.style.display = 'block';
    const apiUrl = apiBaseUrl + '/districts/countries';
    fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        const apiCountriesMap = {};
        if (data.data) {
          data.data.forEach(c => {
            apiCountriesMap[c.code] = c.id;
          });
        }

        const countryOptions = COUNTRY_LIST.map(country => ({
          text: country.name,
          value: country.code,
          parentId: apiCountriesMap[country.code]
        }));

        countrySearch.setOptions(countryOptions);


        const countryVal = countrySelect.value;
        if (countryVal) {
          const match = countryOptions.find(o => o.value === countryVal);
          if (match) {
            countrySearch.setValue(match.value, match.text);
            loadProvinceList(match.value);
            handlePhoneCountryCode(match.value);
          }
        }

        countrySelect.dispatchEvent(new CustomEvent('countriesLoaded'));
        if (countryLoading) countryLoading.style.display = 'none';
      })
      .catch(err => {
        console.error('Error fetching country list:', err);
        // Fallback to basic list if API fails
        const countryOptions = COUNTRY_LIST.map(country => ({
          text: country.name,
          value: country.code
        }));
        countrySearch.setOptions(countryOptions);
        if (countryLoading) countryLoading.style.display = 'none';
      });

  }

  function loadProvinceList(countryCode) {
    const provinceSearchSelect = document.getElementById('province-search-select');
    const provinceText = document.getElementById('province-text');

    if (!countryCode) {
      provinceSearch.setOptions([]);
      provinceSearch.setValue('', 'Select State');
      
      const trigger = provinceSearchSelect.querySelector('.ctm-sign-trader__search-select-trigger');
      if (trigger) trigger.style.display = 'flex'; 
      
      provinceSearchSelect.style.display = 'block';
      provinceText.style.display = 'none';
      provinceSearch.disable(true);
      provinceText.disabled = true;

      countrySelect.setAttribute('required', 'required');
      provinceSelect.setAttribute('required', 'required');
      provinceText.removeAttribute('required');
      return;
    }

    provinceSearch.setValue('', 'Loading...');
    
    const trigger = provinceSearchSelect.querySelector('.ctm-sign-trader__search-select-trigger');
    if (trigger) trigger.style.display = 'flex'; 

    provinceSearchSelect.style.display = 'block';
    provinceText.style.display = 'none';
    provinceSearch.disable(true);
    provinceText.disabled = true;

    const showTextInput = () => {
      const trigger = provinceSearchSelect.querySelector('.ctm-sign-trader__search-select-trigger');
      if (trigger) trigger.style.display = 'none';
      
      provinceSearchSelect.style.display = 'block';
      provinceText.style.display = 'block';
      provinceSearch.disable(false);
      provinceText.disabled = false;
      provinceText.value = '';
      provinceSelect.removeAttribute('required');
      provinceText.setAttribute('required', 'required');
    };

    const countryContainer = document.getElementById('country-search-select');
    const selectedOption = countryContainer.querySelector(`.ctm-sign-trader__search-select-option[data-value="${countryCode}"]`);
    
    if (!selectedOption) {
      showTextInput();
      hideError(provinceSearchSelect);
      hideError(provinceText);
      return;
    }

    const parentId = selectedOption.dataset.parentId;
    
    if (!parentId) {
      showTextInput();
      hideError(provinceSearchSelect);
      hideError(provinceText);
      return;
    }

    const apiUrl = apiBaseUrl + `/districts/children/${parentId}`;
    fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {

        if (!data.data || data.data.length === 0) {
          showTextInput();
          return;
        }

        const provinceOptions = data.data.map(province => ({
          text: province.name,
          value: province.code
        }));

        provinceSearch.setOptions(provinceOptions);
        provinceSearch.setValue('', 'Select State');


        const provinceVal = provinceSelect.value;
        if (provinceVal) {
          const match = provinceOptions.find(o => o.value === provinceVal);
          if (match) provinceSearch.setValue(match.value, match.text);
        }

        provinceSearch.disable(false);
        provinceSelect.dispatchEvent(new CustomEvent('provinceLoaded'));
        
        provinceSelect.setAttribute('required', 'required');
        provinceText.removeAttribute('required');
      }).catch(error => {
        console.error('Error fetching province data:', error);
        showTextInput();
      });

    hideError(provinceSearchSelect);
    hideError(provinceText);
  }


  countrySelect.addEventListener('change', function () {
    hideError(provinceSelect);
    hideError(provinceText);

    const provinceField = document.querySelector('.ctm-sign-trader__field:has(#province)');
    if (provinceField) {
      const errors = provinceField.querySelectorAll('.ctm-sign-trader__error');
      errors.forEach(error => error.remove());
    }

    loadProvinceList(this.value);
    handlePhoneCountryCode(this.value);
  });



  function initFilePreview() {
    const filePreviewList = document.querySelector('.ctm-sign-trader__file-preview-list');
    if (!filePreviewList) return;

    filePreviewList.innerHTML = '';
    uploadedFiles.forEach(file => addFileToPreview(file));
  }

  function addFileToPreview(file) {
    const filePreviewList = document.querySelector('.ctm-sign-trader__file-preview-list');
    if (!filePreviewList) return;

    const fileItem = document.createElement('div');
    fileItem.className = 'ctm-sign-trader__file-preview-item';

    const fileIcon = document.createElement('span');
    fileIcon.style.marginRight = '0.5rem';
    fileIcon.style.fontSize = '1.125rem';

    const fileExt = file.fileId.split('.').pop().toLowerCase();
    if (fileExt === 'pdf') fileIcon.textContent = 'PDF';
    else if (fileExt.match(/jpg|jpeg|png/)) fileIcon.textContent = 'IMG';
    else fileIcon.textContent = 'FILE';

    const fileName = document.createElement('span');
    fileName.href = file.fileId;
    fileName.style.color = '#5c3a1d';
    fileName.style.marginLeft = '0.5rem';
    fileName.style.overflow = 'hidden';
    fileName.textContent = file.fileName;

    const removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'ctm-sign-trader__file-preview-remove';
    removeBtn.textContent = 'Remove';
    removeBtn.setAttribute('aria-label', `Remove ${file.fileName}`);
    removeBtn.onclick = function () {
      fileItem.remove();
      uploadedFiles = uploadedFiles.filter(f => f.fileName !== file.fileName);
      if (uploadedFiles.length === 0) {
        fileInput.value = ''
      }
      if (currentStep === 2) validateStep(currentStep);
    };

    fileItem.appendChild(fileIcon);
    fileItem.appendChild(fileName);
    fileItem.appendChild(removeBtn);
    filePreviewList.appendChild(fileItem);
  }

  fileInput.addEventListener('change', function (e) {
    hideError(fileInput);

    const file = e.target.files[0];
    if (!file) return;

    if (uploadedFiles.length >= MAX_FILES) {
      showError(fileInput, `You can upload up to ${MAX_FILES} files.`);
      fileInput.value = '';   
      return;
    }

    if (file.size > MAX_FILE_SIZE) {
      showError(fileInput, `${file.name} is too large. Maximum size is 10MB.`);
      fileInput.value = '';   
      return;
    }

    const validTypes = ['application/pdf', 'image/jpeg', 'image/png'];
    if (!validTypes.includes(file.type)) {
      showError(fileInput, `Please upload PDF, JPG, or PNG files.`);
      fileInput.value = ''; 
      return;
    }


    const formData = new FormData();
    formData.append('file', file);
    loadingOverlay.show('Uploading...');

    const uploadUrl = apiBaseUrl + '/file/upload';
    fetch(uploadUrl, {
      method: 'POST',
      body: formData
    })
      .then(response => {
        if (!response.ok) throw new Error('File upload failed');
        return response.json();
      })
      .then(data => {
        loadingOverlay.hide();
        fileInput.value = '';
        if (data.data) {
          ctmToast.show('Upload success', 2000)
          uploadedFiles.push({
            fileId: data.data,
            fileName: data.data.fileName || file.name
          });
          initFilePreview();
        } else {
          throw new Error('Invalid response from server');
        }
      })
      .catch(error => {
        loadingOverlay.hide();
        showError(fileInput, `Upload failed: ${error.message}`);
        if (uploadedFiles.length === 0) {
          fileInput.value = ''
        }
      })

  });

  function handlePhoneCountryCode(countryCode) {
    const phoneCountrySelect = document.getElementById('ctm-country-select');
    if (phoneCountrySelect && countryCode) {
      phoneCountrySelect.value = countryCode;
      phoneCountrySelect.dispatchEvent(new Event('change'));
    }
  }

  function initPhoneCountrySelector() {
    const countrySelect = document.getElementById('ctm-country-select');
    const flagImg = document.querySelector('.ctm-phone-country-flag');
    const dialCodeSpan = document.getElementById('ctm-phone-dial-code');
    const countryWrapper = document.querySelector('.ctm-phone-country-wrapper');
    const phoneInput = document.getElementById('phone');

    if (!countrySelect || !flagImg) return;

    const adjustPadding = () => {
      if (countryWrapper && phoneInput) {
        const left = parseInt(getComputedStyle(countryWrapper).left) || 0;
        const width = countryWrapper.offsetWidth;
        const padding = Math.max(80, left + width + 4);
        phoneInput.style.paddingLeft = `${padding}px`;
      }
    };

    if (window.ResizeObserver && countryWrapper) {
      new ResizeObserver(() => adjustPadding()).observe(countryWrapper);
    }

    countrySelect.innerHTML = '';

    COUNTRY_LIST.forEach(country => {
      const option = document.createElement('option');
      option.value = country.code;
      option.textContent = country.name;
      if (country.code === 'US') option.selected = true;
      countrySelect.appendChild(option);
    });

    countrySelect.addEventListener('change', (e) => {
      const selectedCode = e.target.value;
      const selectedCountry = COUNTRY_LIST.find(c => c.code === selectedCode);
      if (selectedCountry) {
        flagImg.alt = selectedCountry.name;
        flagImg.src = `https://purecatamphetamine.github.io/country-flag-icons/3x2/${selectedCode}.svg`;
        if (dialCodeSpan) {
          dialCodeSpan.textContent = selectedCountry.dial_code || '';
        }
        setTimeout(adjustPadding, 0);
      }
    });

    // Initial load
    const initialCountry = COUNTRY_LIST.find(c => c.code === 'US');
    if (initialCountry) {
      flagImg.alt = initialCountry.name;
      flagImg.src = `https://purecatamphetamine.github.io/country-flag-icons/3x2/${initialCountry.code}.svg`;
      if (dialCodeSpan) dialCodeSpan.textContent = initialCountry.dial_code || '';
      adjustPadding();
    }
  }
  
  initPhoneCountrySelector();

  function updateStepDisplay() {
    stepContents.forEach(content => {
      content.style.display = 'none';
    });
    document.getElementById(`step-${currentStep}`).style.display = 'block';
    TraderFormAccessibility.updateStep({ stepContents, currentStep, steps, shouldFocus: true });

    if (currentStep === 2) {
      const countryContainer = document.getElementById('country-search-select');
      const options = countryContainer ? countryContainer.querySelectorAll('.ctm-sign-trader__search-select-option') : [];
      if (options.length === 0) {
        initCountryList();
      }
    }
    if (currentStep === 2) {
      initFilePreview()
    }

    const notes = document.querySelector('.ctm-sign-trader__notes');
    if (notes) {
      notes.style.display = currentStep === 1 ? 'block' : 'none';
    }


    const progressStep = document.querySelector('.ctm-sign-trader__progress-step');
    const progressLabel = document.querySelector('.ctm-sign-trader__progress-label');
    const progressFill = document.querySelector('.ctm-sign-trader__progress-fill');

    if (progressStep && progressLabel && progressFill) {
      progressStep.textContent = `STEP ${currentStep} OF ${steps.length}`;

      if (currentStep === 1) {
        progressLabel.textContent = 'ACCOUNT ACCESS';
        progressFill.style.width = '50%';
      } else if (currentStep === 2) {
        progressLabel.textContent = 'BUSINESS INFO';
        progressFill.style.width = '100%';
      }
    }


    if (traderTitle) {
      traderTitle.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    if (currentStep === 1) {
      prevButtons.forEach(btn => btn.style.display = 'none');
    } else {
      prevButtons.forEach(btn => btn.style.display = 'block');
    }
  }



  prevButtons.forEach(button => {
    button.addEventListener('click', function () {
      if (currentStep > 1) {
        currentStep--;
        disableStep1Fields(true);
        updateStepDisplay();
      }
    });
  });

  if (submitButton) {
    submitButton.addEventListener('click', async function (e) {
      e.preventDefault();
      if (validateStep(2)) {
        loadingOverlay.show('Submitting...');

        try {
          const businessTypeVal = (function () {
            const sel = document.getElementById('business_type');
            if (sel.value === 'Other') {
              const otherText = document.getElementById('business_type_other').value.trim();
              return 'Other:' + otherText;
            }
            return sel.value;
          })();

          const hearFromVal = (function () {
            const sel = document.getElementById('hear_about');
            if (sel.value === 'Other') {
              const otherText = document.getElementById('hear_about_specify').value.trim();
              return 'Other:' + otherText;
            }
            if (sel.value === 'Online Search') {
              const detail = document.getElementById('online_search_detail')?.value.trim();
              return detail ? `Online Search: ${detail}` : 'Online Search';
            }
            return sel.value;
          })();

          const referralEmail = document.getElementById('referral_email_input')?.value || '';

          const requestData = {
            phone: (document.getElementById('ctm-phone-dial-code')?.innerText || '') + document.getElementById('phone').value,
            country: document.getElementById('country').value,
            streetAddress: document.getElementById('street').value,
            floor: document.getElementById('apt').value,
            city: document.getElementById('city').value,
            province: document.getElementById('province').value || document.getElementById('province-text').value,
            zipCode: document.getElementById('zip').value,
            website: document.getElementById('website').value,
            primaryBusinessFocus: document.getElementById('focus').value,
            eligibilityFile: uploadedFiles.map(file => file.fileId).join(','),
            businessType: businessTypeVal,
            hearFrom: hearFromVal,
            recommenderEmail: referralEmail,
            message: document.getElementById('message').value,
            emailUpdatesConsent: document.getElementById('email_updates').checked ? 1 : 0,
            code: window.code,
            referralId: affParam || '',
            shopId: theme.ctm.shopId
          };

          const submitResp = await theme.utils.customFetch(`${apiBaseUrl}/trade-user/v2/submit`, requestData);
          const submitResult = await submitResp.json();

          if (submitResult.code !== 200) {
            throw new Error(submitResult.message);
          }


          document.getElementById('successModal').show();
          const email = document.getElementById('email').value;
          if (window.Shopify && Shopify.analytics) {
            // Shopify.analytics.publish('ctm_trade_generate_lead', {
            //   user_id: btoa(unescape(encodeURIComponent(email)))
            // });
          }
          // if (window.gtag) {
          //   window.gtag('event', 'trade_form_submit');
          // }

          // setTimeout(() => {
          //   const successBtn = document.querySelector('ctm-apply-success-modal .ctm-sign-btn');
          //   if (successBtn) {
          //     successBtn.onclick = function () {
          //       window.location.href = '/collections/best-sellers';
          //     }
          //     successBtn.textContent = 'Get to know us';
          //   }
          // }, 500);

        } catch (err) {
          ctmToast.show(err.message || 'Submission failed');
        } finally {
          loadingOverlay.hide();
        }
      }
    });
  }


  nextButtons.forEach(button => {
    button.addEventListener('click', async function () {
      if (currentStep === 1) {
        if (validateStep(1)) {
          loadingOverlay.show('Loading...');
          try {
            const reqData = {
              firstName: document.getElementById('first_name').value,
              lastName: document.getElementById('last_name').value,
              email: document.getElementById('email').value,
              companyName: document.getElementById('company_name').value,
              jobTitle: document.getElementById('job_title').value,
              referralId: affParam || '',
              shopifyCustomerId: rfe || '',
              shopId: theme.ctm.shopId
            };


            const resp = await theme.utils.customFetch(`${apiBaseUrl}/trade-user/v2/step1`, reqData);
            const res = await resp.json();
            if(res.code === 200) {
              window.code = res.data.code;
              disableStep1Fields();

              currentStep = 2;
              updateStepDisplay();
              traderTitle.scrollIntoView({ behavior: 'smooth', block: 'start' });
            } else {
                ctmToast.show(res.message);
            }
          } catch (e) {
            console.error(e);
            ctmToast.show('Error processing request');
          } finally {
            loadingOverlay.hide();
          }
        }
      }
    });
  });

  function validateStep(step) {
    let isValid = true;
    let firstErrorField = null;
    const stepContent = document.getElementById(`step-${step}`);


    const requiredFields = stepContent.querySelectorAll('[required]');
    requiredFields.forEach(field => {

      if (field.disabled) return;


      let displayField = field;
      if (field.type === 'hidden' && field.closest('.ctm-sign-trader__search-select')) {
        displayField = field.closest('.ctm-sign-trader__search-select').querySelector('.ctm-sign-trader__search-select-trigger');
      } else if (field.offsetParent === null) {
        return;
      }

      let valid = true;
      const label = field.closest('.ctm-sign-trader__field')?.querySelector('label');
      let labelText = label?.innerText?.replace('*', '').trim() || 'This field';
      

      if (labelText.toLowerCase().includes('what best describes your role')) {
        labelText = 'Role';
      } 
      

      if (labelText === labelText.toUpperCase()) {
        labelText = labelText.charAt(0).toUpperCase() + labelText.slice(1).toLowerCase();
      }
      
      if (!field.value.trim() && field.id !== 'documents') {
        showError(displayField, `${labelText} is required`);
        valid = false;
      } else if (field.type === 'email') {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(field.value.trim())) {
          showError(field, 'Please enter a valid email address');
          valid = false;
        }
      } else if (field.type === 'checkbox') {
        if (!field.checked) {
          const label = field.closest('label');
          let msg = 'This field is required';
          if (field.id === 'privacy_policy') {
            msg = 'Please agree to the Privacy Policy and Terms of Use';
          } else if (field.id === 'email_updates') {
            msg = 'Please confirm you would like to receive email updates';
          }
          
          showError(label || field, msg);
          valid = false;
        }
      }

      if (valid) hideError(field.type === 'checkbox' ? field.closest('label') || field : field);
      else isValid = false;

      if (!isValid && !firstErrorField) firstErrorField = field;
    });


    if (step === 2) {

      if (uploadedFiles.length === 0) {
        showError(fileInput, 'Please upload at least one document');
        isValid = false;
        if (!firstErrorField) firstErrorField = fileInput;
      } else {
        hideError(fileInput);
      }


      const phoneInput = document.getElementById('phone');
      if (phoneInput && phoneInput.value.trim()) {
        const phoneValue = phoneInput.value.trim();
        if (phoneValue.length < 7) {
          showError(phoneInput, 'Phone number must be at least 7 digits (excluding country code)');
          isValid = false;
          if (!firstErrorField) firstErrorField = phoneInput;
        }
      }


      const bType = document.getElementById('business_type');
      if (bType.value === 'Other') {
        const otherIn = document.getElementById('business_type_other');
        if (!otherIn.value.trim()) {
          showError(otherIn, 'Please specify details');
          isValid = false;
          if (!firstErrorField) firstErrorField = otherIn;
        }
      }


      const web = document.getElementById('website');
      if (web.value.trim() && !isValidWebsiteUrl(web.value.trim())) {
        showError(web, 'Please enter a valid website URL');
        isValid = false;
        if (!firstErrorField) firstErrorField = web;
      }
    }

    if (!isValid && firstErrorField) {
      firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
      TraderFormAccessibility.focusField(firstErrorField);
    }
    return isValid;
  }

  function isValidWebsiteUrl(url) {
    if (!url.trim()) return true;

    return url.includes('.');
  }

});
